import './SettingsNotification.scss'

import React, {Component} from 'react'

import { push } from 'react-router-redux'
import SettingsSelect from './SettingsSelect.js'

import {
  NOTIFICATION_MODES
} from 'common/constants'

const SettingsNotification = ({dispatch, settings, onSelect}) => {
  return (
    <div className="SettingsNotification">
      <div className="Settings__label">Notification Mode</div>
      <SettingsSelect multiselect={false} options={NOTIFICATION_MODES.filter(item => settings.has_active_push_devices || item.value == 'sms')} selected={settings.notification_mode} onClick={onSelect} />
    </div>
  )
}

export default SettingsNotification
